const variants = { primary: 'primary' };
export default variants;
